<template>
  <div>
    <div>
      <p
        class="message sign-container"
        v-if="$route.name === 'user-profile' && !requestData.id"
      >
        Sin firma configurada dentro de la empresa, contáctese con su administrador
      </p>
    </div>
    <div class="sign-container" v-if="showForm && !exitMessage">
      <!-- ESTADO DE LA FIRMA -->
      <div class="row mb-2" v-if="requestData.id">
        <vs-icon class="col-1" icon="adjust"></vs-icon>
        <label class="col-3 text-left">Estado de la firma:</label>
        <label class="col-2 text-left"><b>{{ signData.active ? 'Activa' : 'Inactiva' }}</b></label>
      </div>
      <p class="text-muted" v-if="$route.name === 'users-management' && !signActive">
        Al activar la firma, esta persona podrá firmar y estampar sus documentos
        digitalmente en las aprobaciones. ¡Listo, es solo un clic!
      </p>
      <!-- BOTON -->
      <div class="row d-block text-center" v-if="$route.name !== 'user-profile'">
        <b-button
          v-if="signActive"
          variant="secondary"
          @click="close"
        >
          Cerrar
        </b-button>
        <b-button
          v-else
          :disabled="loading"
          variant="warning"
          @click="saveSignature"
        >
          Activar firma
          <b-spinner small v-if="loading" variant="primary"/>
        </b-button>
      </div>
    </div>
    <div
      class="text-center alert alert-success p-3"
      role="alert"
      v-show="exitMessage && $route.name === 'users-management'"
    >
      Identificador de firma grabado exitosamente. Puede cerrar esta ventana.
    </div>
    <!-- Configuración de estampa (perfil del usuario) -->
    <div v-if="requestData.id && $route.name === 'user-profile'" class="mt-4">
      <ConfigureStamp
        prefix="segpres"
        proveedor="Segpres"
        tipoFirma="firmaAvanzada"
        :user="user"
        :customConfigIds="stampConfigIds"
      />
    </div>
    <!-- Vista previa de la estampa (administración de usuarios) -->
    <div v-if="requestData.id && $route.name !== 'user-profile'" class="mt-4">
      <PreviewStamp
        prefix="segpres"
        proveedor="Segpres"
        tipoFirma="firmaAvanzada"
        :user="user"
        :customConfigIds="stampConfigIds"
      />
    </div>
  </div>
</template>

<script>
import { configureAdvancedSign } from '@/febos/servicios/api/usuarios.api';
import ConfigureStamp from '@/febos/global/usuario/components/sign/shared/ConfigureStamp';
import PreviewStamp from '@/febos/global/usuario/components/sign/shared/PreviewStamp';

export default {
  name: 'AvanzadaSignSegpres',
  components: { ConfigureStamp, PreviewStamp },
  data() {
    return {
      loading: false,
      // IDs alineados con el firmador real (FirmadorSegpress): el fondo de la
      // plantilla es io.firma.segpres.imagen (no el de "copia fiel"), para que
      // la configuracion/preview se vean igual que la firma estampada.
      stampConfigIds: {
        tipo: 'io.firma.segpres.tipo',
        plantilla: 'io.firma.segpres.template',
        imagen: 'io.firma.segpres.imagen',
        background: 'io.firma.segpres.imagen',
        representacion: 'io.firma.segpres.representacion',
        alto: 'io.firma.segpres.al',
        ancho: 'io.firma.segpres.an'
      },
      signData: {
        id: null,
        active: null,
        attended: true,
        extraData: null,
        hash: null,
      },
      exitMessage: null,
    };
  },
  created() {
    this.signData.id = this.requestData.id;
    this.signData.active = this.requestData.respuestaAvanzada.activa;
    this.signData.extraData = this.requestData.respuestaAvanzada.extraData;
    this.signData.hash = this.requestData.respuestaAvanzada.hash;
  },
  computed: {
    showForm() {
      return this.$route.name === 'users-management'
        || (this.requestData.id && this.$route.name === 'user-profile');
    },
    /** La firma ya está creada y activa: no hay nada que guardar. */
    signActive() {
      return !!this.signData.id
        && (this.signData.active === true || this.signData.active === 'Y');
    }
  },
  methods: {
    close() {
      this.$emit('cancel');
    },
    async saveSignature() {
      this.loading = true;
      // Al activar/guardar desde la administración, la firma queda activa sin
      // requerir datos del usuario (entidad y credenciales se definen a nivel
      // empresa en el Mantenedor de integraciones).
      const activa = this.signData.id ? this.signData.active : true;
      const data = {
        idUsuarioFirma: this.user.id,
        proveedor: 'Segpres',
        tipoFirma: 'firmaAvanzada',
        requestSegpres: {
          id: this.signData.id,
          activa,
          atendida: this.signData.attended,
          extraData: this.signData.extraData,
          hash: this.signData.hash
        },
      };
      try {
        await configureAdvancedSign(data);
        this.exitMessage = true;
        if (this.$route.name === 'user-profile') {
          this.$emit('activate');
        }
        this.loading = false;
      } catch {
        this.loading = false;
      }
    }
  },
  props: {
    user: { type: Object },
    signConfiguration: { type: Object },
    requestData: { type: Object }
  }
};
</script>
<style scoped>
.sign-container {
  padding: 0 100px;
}
.message {
  color: white;
  font-weight: normal;
  background: #ea7037;
  border-radius: 10px 10px 10px 10px;
  padding: 10px;
}
</style>
